<div class="flex gap-1 items-center">
  <app-star-rating [rating]="rating?.averageRating" [readOnly]="true" />
  @if (!!rating?.averageRating && !!rating?.ratingsCount) {
    <span class="text-subText text-xs">({{ rating?.ratingsCount ?? 0 }} {{ ratingsText }})</span>
  }
</div>
